<template>
  <div class="app-container certification">
    <div class="header">
      <el-input
        placeholder="请输入姓名"
        v-model="listQuery.search"
        :clearable="true"
        style="width: 200px"
      ></el-input>
      <el-select
        placeholder="是否通过"
        v-model="listQuery.apply_status"
        :clearable="true"
        style="margin: 0 15px;"
      >
        <el-option label="未审核" value="1"></el-option>
        <el-option label="通过" value="2"></el-option>
        <el-option label="拒绝" value="3"></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="search">搜索</el-button>
    </div>

    <el-dialog v-if="showDialog" title="驳回" :visible.sync="showDialog">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="驳回原因">
          <el-input v-model="form.refuse_reason" type="textarea" :rows="10"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="handleCancel">取消</el-button>
          <el-button size="small" type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{ scope.$index+1}}</template>
      </el-table-column>
      <el-table-column label="头像" align="center" min-width="150">
        <template slot-scope="scope">
          <img :src="scope.row.user.avatar" alt style="width: 110px;" />
        </template>
      </el-table-column>
      <el-table-column label="昵称" align="center" min-width="110">
        <template slot-scope="scope">
          {{
          scope.row.user.nickname
          }}
        </template>
      </el-table-column>
      <el-table-column label="联系电话" align="center" min-width="110">
        <template slot-scope="scope">
          {{
          scope.row.user.phone
          }}
        </template>
      </el-table-column>
      <el-table-column label="姓名" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column label="身份证号码" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.id_card_number }}</template>
      </el-table-column>
      <!-- <el-table-column label="身份证正面" align="center" min-width="200">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.id_card_hand"
            :preview-src-list="[scope.row.id_card_hand]"
          ></el-image>
        </template>
      </el-table-column> -->
      <el-table-column label="身份证正面" align="center" min-width="200">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.id_card_positive"
            :preview-src-list="[scope.row.id_card_positive]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="身份证反面" align="center" min-width="200">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.id_card_reverse"
            :preview-src-list="[scope.row.id_card_reverse]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.created_at }}</template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="95">
        <template slot-scope="scope">
          <div v-if="scope.row.apply_status == 1">
            <el-tag type="info">未审核</el-tag>
          </div>
          <div v-else-if="scope.row.apply_status == 2">
            <el-tag type="success">通过</el-tag>
          </div>
          <div v-else-if="scope.row.apply_status == 3">
            <el-tag type="danger">拒绝</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="250">
        <template slot-scope="scope" v-if="scope.row.apply_status == 1">
          <el-button size="small" type="primary" @click="handlePass(scope.row)">通过</el-button>
          <el-button size="small" type="danger" @click="handleRefuse(scope.row)">驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[5, 10, 20, 30, 50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: true,
      total: 1,
      listQuery: {
        page: 1,
        limit: 5,
        search: "",
        apply_status: ""
      },
      list: [],
      form: {
        id: "",
        refuse_reason: ""
      },
      showDialog: false,
      btnLoading: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      request({
        url: "/api/backend/userCertification",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.$notify.error(err);
        });
    },
    resetData() {
      this.btnLoading = false;
      this.form.id = "";
      this.form.refuse_reason = "";
      this.showDialog = false;
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    pass(row) {
      request({
        url: "/api/backend/userCertification/agree",
        method: "post",
        data: { id: row.id }
      })
        .then(result => {
          this.$notify.success("操作成功");
          this.getList();
        })
        .catch(err => {
          this.$notify.error("操作失败");
        });
    },
    handlePass(row) {
      this.$confirm("此操作将会通过该用户的审核，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(result => {
          this.pass(row);
        })
        .catch(err => {
          this.$notify.info("已取消");
        });
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleRefuse(row) {
      this.showDialog = true;
      this.form.id = row.id;
    },
    handleCancel() {
      this.resetData();
      this.$notify.info("已取消");
    },
    handleSubmit() {
      this.btnLoading = true;
      request({
        url: "/api/backend/userCertification/refuse",
        method: "post",
        data: this.form
      })
        .then(result => {
          this.getList();
          this.resetData();
          this.$notify.success("操作成功");
        })
        .catch(err => {
          this.$notify.error("操作失败");
        });
    }
  }
};
</script>

<style></style>
